// BootstrapTextField.js
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

// Styled MUI TextField that mimics Bootstrap Form.Control
const BootstrapTextField = styled(TextField)(({ theme }) => ({
    // Base input wrapper
    "& .MuiOutlinedInput-root": {
        borderRadius: ".25rem",
        height: 38,
        fontSize: "13px",
        lineHeight: 1.5,
        padding: "0 .75rem",
        backgroundColor: "#fff",

        // Default border
        "& fieldset": {
            borderColor: "#ced4da",
        },

        // Hover (matches :hover of .form-control)
        "&:hover fieldset": {
            borderColor: "#b3c2d4",
        },

        // Focus ring (Bootstrap 5 blue/box‑shadow)
        "&.Mui-focused fieldset": {
            borderColor: "#86b7fe",
            //   boxShadow: "0 0 0 .25rem rgba(13, 110, 253, .25)",
        },
    },

    // Autocomplete specific styles - when used inside Autocomplete with sizeSmall
    "&.MuiAutocomplete-inputRoot .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
        paddingTop: "6px",
        paddingBottom: "6px",
        paddingLeft: "6px",
        backgroundColor: "#fff",
    },

    // Input padding (trim default MUI 14 px)
    "& .MuiInputBase-input": {
        padding: 0,
    },

    // Placeholder color to match Bootstrap
    "& input::placeholder": {
        color: "#6c757d",
        opacity: 1,
    },

    // Helper/error text alignment
    "& .MuiFormHelperText-root": {
        marginLeft: 0,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
        borderColor: "#ff6c6c",
    },
    "& .MuiFormHelperText-root.Mui-error": {
        color: "#ff6c6c",
        marginLeft: 0,
    },
}));

export default BootstrapTextField;
